export default function About() {
  return (
    <section>
      <h1>About</h1>
      <p>React + TypeScript + Vite + React Router.</p>
    </section>
  )
}
